import React, {Component} from 'react';
import "./Menu.css";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { Link } from 'react-router';
import ModalStore from "./stores/ModalStore";



class MenuItem extends Component {
	constructor () {
		super();
		this.state = {
			hide: true
		}
	}
	render() {
		return (
			<div className="calendar-menu-item " onMouseEnter={()=>this.setState({hide: false})}
				 onMouseLeave={()=>this.setState({hide: true})}>
				{this.props.first}
				<ReactCSSTransitionGroup transitionName="dropdown" transitionEnterTimeout={275} transitionLeaveTimeout={275}>
					{!this.state.hide && this.props.children ? (
						<div className="calendar-menu-item-child">
							{this.props.children}
						</div>
					) : null}
				</ReactCSSTransitionGroup>
			</div>
		);
	}
}

export default class Menu extends Component {
	constructor () {
		super();
		this.state = {
			hide: true
		}
	}
	render() {
		return (
			<div className="calendar-menu">
				<MenuItem first={<Link to={"calendar"}>Calendario</Link>}>
					<div onClick={()=>ModalStore.openModal("form-service")}>Agregar nuevo servicio</div>
					<div onClick={()=>ModalStore.openModal("form-service-route")}>Agregar nueva ruta</div>
					<div onClick={()=>ModalStore.openModal("form-model")}>Agregar nuevo modelo</div>
					<div onClick={()=>ModalStore.openModal("form-bus")}>Agregar nuevo autobus</div>
					<div onClick={()=>ModalStore.openModal("form-contractor")}>Agregar nuevo contratante</div>
					<div onClick={()=>ModalStore.openModal("form-edit-contractor")}>Editar contratante</div>
				</MenuItem>
				<MenuItem first={<Link to={"reports"}>Reportes</Link>}/>
				<MenuItem first={<a onClick={()=>{
					window.localStorage.removeItem("token");
					window.location.href = "/login";
				}}>Cerrar sesión</a>}/>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Menu.js
 **/